































import {Component, Provide, Vue} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import axios from 'axios';
import {baseUrlAPI} from '@/globals';
import {addAuthorizationHeader} from '@/domain/util/libraries/AxiosConfig';
import ErrorNotifier from '@/domain/util/notifications/ErrorNotifier';
import UserState from '@/store/modules/user/types';
import HomeFooter from '@/components/common/home/HomeFooter.vue';

@Component({ components: { HomeFooter } })
export default class Home extends Vue {

    @Provide()
    public date = new Date();

    @Provide()
    public user = {
        name: '',
        password: '',
    };

    @Provide()
    public isLoad = false;

    @State('user') public userState!: UserState;
    @Action public getUser: any;

    public async login() {

        axios.post(`${baseUrlAPI}login`, this.user).then((response) => {
            this.userState.token = 'Bearer ' + response.data.access_token;
            this.userState.role = response.data.role;
            addAuthorizationHeader(this.userState);
            this.getUser();
        }).catch((error) => {
            if (error.response && error.response.status === 401) {
                ErrorNotifier.notifyWithCustomMessage('Аутентификация не удалась: неверное имя пользователя или пароль');
            } else if (error.response && error.response.data.msg) {
                ErrorNotifier.notifyWithCustomMessage(error.response.data.msg);
            } else if (error.message) {
                ErrorNotifier.notifyWithCustomMessage(error.message);
            } else {
                ErrorNotifier.notifyWithCustomMessage('Аутентификация не удалась: неизвестная ошибка');
            }
            this.user.password = '';
        });

    }

}
